/**
* DevExpress Analytics (core\elements\margins.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ko = require("knockout");
var paddingModelMetaData_1 = require("./paddingModelMetaData");
var Margins = (function () {
    function Margins(left, right, top, bottom) {
        this.bottom = ko.observable(bottom);
        this.left = ko.observable(left);
        this.right = ko.observable(right);
        this.top = ko.observable(top);
    }
    Margins.prototype.getInfo = function () {
        return paddingModelMetaData_1.paddingSerializationsInfo;
    };
    Margins.prototype.isEmpty = function () {
        return this.toString() === Margins.defaultVal;
    };
    Margins.fromString = function (value) {
        if (value === void 0) { value = Margins.defaultVal; }
        var components = value.split(',');
        return new Margins(parseInt(components[0]), parseInt(components[1]), parseInt(components[2]), parseInt(components[3]));
    };
    Margins.prototype.toString = function () {
        var result = Math.round(this.left()) + ', ' + Math.round(this.right()) + ', ' + Math.round(this.top()) + ', ' + Math.round(this.bottom());
        return result;
    };
    Margins.defaultVal = '100, 100, 100, 100';
    Margins.unitProperties = ['left', 'right'];
    return Margins;
}());
exports.Margins = Margins;
